import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule , ReactiveFormsModule } from '@angular/forms' ;

import { HttpClientModule} from '@angular/common/http';

import {RecaptchaModule} from 'ng-recaptcha';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NosotrosComponent } from './components/nosotros/nosotros.component';
import { ServiciosComponent } from './components/servicios/servicios.component';
import { ContactoComponent } from './components/contacto/contacto.component';
import { InicioComponent } from './components/inicio/inicio.component';
import { ErrorComponent } from './components/error/error.component';
import { TermCondiComponent } from './components/term-condi/term-condi.component';
import { PoliticaPrivacidadUsoComponent } from './components/politica-privacidad-uso/politica-privacidad-uso.component';
import { ReviewsComponent } from './components/reviews/reviews.component';
import { ModalComponent } from './components/modal/modal.component';

@NgModule({
  declarations: [
    AppComponent,
    NosotrosComponent,
    ServiciosComponent,
    ContactoComponent,
    InicioComponent,
    ErrorComponent,
    TermCondiComponent,
    PoliticaPrivacidadUsoComponent,
    ReviewsComponent,
    ModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule ,
    ReactiveFormsModule,
    HttpClientModule,
    RecaptchaModule,

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
